import React from "react"

const Banner = () => {
  return (<div className="header-banner">

  </div>)}

export default Banner